const webinarsData = [
    {
        name: 'Middle East conflict and ceasefire: Oil, Gas and Gold ',
        videoId: 'BFhn4oZz3pA'
    },
    {
        name: 'Trade war 90 day suspension expiring',
        videoId: 'qumDN_ZH7j8'
    },
    {
        name: 'Earnings Season kicks off',
        videoId: 'G33zeD7Qo94'
    },
    {
        name: 'Fed Interest Rate Decision',
        videoId: 'J3-vD4EQlzk'
    },
    {
        name: 'NFP and Unemployment Rate',
        videoId: 'oqDYLdifEtE'
    },
]

export default webinarsData;